import React from "react";
import { included } from "../data/landing";
import { CTAButton } from "./CTAButton";
import { MobileAccordion } from "./MobileAccordion";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
export function IncludedSection() {
  return <section aria-labelledby="incluye" className="section-pad border-b border-line" data-id="element-254" data-mp="3cdxx2k3sp5v6">
      <div className="page-container grid gap-10 md:gap-12 lg:grid-cols-12 lg:gap-8" data-id="element-255" data-mp="3cg295pbulb6j">
        <Reveal className="lg:col-span-4" data-id="element-256" data-mp="40ikl3m4ggxt">
          <SectionHeader number="05" label="Lo que instalamos" titleId="incluye" title="Una tubería simple para que tus leads no se pierdan." data-id="element-257" data-mp="8097gw8j2cx2" />
          <div className="mt-10 hidden lg:block" data-id="element-258" data-mp="3vca8kci6irtx">
            <CTAButton source="included" data-id="element-259" data-mp="3vaz224xcn5z4" />
          </div>
        </Reveal>

        <MobileAccordion items={included.map((item, i) => ({
        id: `incluye-${i}`,
        title: item.title,
        content: <p className="body-copy" data-id="element-261" data-mp="3qh44ahiocy17">{item.body}</p>
      }))} data-id="element-260" data-mp="mvp6lfnysz0b" />

        <ul className="hidden gap-x-10 self-start md:grid md:grid-cols-2 lg:col-span-8" data-id="element-262" data-mp="3qf1enylfp6x0">
          {included.map((item, i) => <li key={item.title} className="border-t border-line" data-id="element-263" data-mp="419mim462d45" data-mpi={i}>
              <Reveal delay={i * STAGGER} className="flex gap-3 py-5" data-id="element-264" data-mp="43mc9lg61rrr">
                <span className="font-ui font-bold text-gold" aria-hidden="true" data-id="element-265" data-mp="3vffdqr5256iw">
                  →
                </span>
                <div data-id="element-266" data-mp="e1to5pvlljmw">
                  <h3 className="h3-item" data-id="element-267" data-mp="90mf7nhpyeen">{item.title}</h3>
                  <p className="body-copy mt-1" data-id="element-268" data-mp="904g8j3o9m31">{item.body}</p>
                </div>
              </Reveal>
            </li>)}
        </ul>

        <div className="hidden md:block lg:hidden" data-id="element-269" data-mp="i1kdrq9e1tpu">
          <CTAButton source="included" data-id="element-270" data-mp="i23uj3nayc2a" />
        </div>
      </div>
    </section>;
}